import { render, staticRenderFns } from "./SessionBar.vue?vue&type=template&id=2c0ccc6a&scoped=true"
import script from "./SessionBar.vue?vue&type=script&lang=ts"
export * from "./SessionBar.vue?vue&type=script&lang=ts"
import style0 from "./SessionBar.vue?vue&type=style&index=0&id=2c0ccc6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ccc6a",
  null
  
)

export default component.exports